(() => {
	const ACTION = "yampi-buy-now";

	// Serialize a form for /cart/add.js
	function encodeForm(form) {
		const fd = new FormData(form);
		return new URLSearchParams(fd).toString();
	}

	// Resolve the nearest product form element
	function resolveProductForm(el) {
		const pf = el.closest("product-form");
		if (pf) return pf.querySelector("form");
		return el.closest("form");
	}

	// Add current variant + quantity to cart with better error parsing
	async function addToCart(form) {
		const payload = encodeForm(form);
		const res = await fetch("/cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
				"X-Requested-With": "XMLHttpRequest",
			},
			body: payload,
		});

		let data = null;
		try {
			data = await res.json();
		} catch (_) {}

		if (!res.ok || (data && data.status)) {
			const msg =
				(data && (data.description || data.message)) ||
				"Falha ao adicionar ao carrinho.";
			const err = new Error(msg);
			err.response = data;
			throw err;
		}

		return data;
	}

	// Clear current cart so checkout only carries the selected product
	async function clearCart() {
		const res = await fetch("/cart/clear.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
				"X-Requested-With": "XMLHttpRequest",
			},
			body: "",
		});

		if (!res.ok) {
			const err = new Error("Falha ao preparar o checkout rápido.");
			err.response = res;
			throw err;
		}
	}

	document.addEventListener(
		"click",
		async (e) => {
			const btn = e.target.closest("[data-yampi-buy-now]");
			if (!btn) return;

			// Prevent re-entry/double clicks
			if (btn.matches('[aria-disabled="true"], .btn--loading')) return;

			e.preventDefault();

			const form = resolveProductForm(btn);
			if (!form) {
				console.warn("[Yampi Buy Now] No form found near button.");
				return;
			}

			// Visual lock & accessibility
			btn.setAttribute("aria-disabled", "true");
			btn.classList.add("btn--loading");
			try {
				form.setAttribute("aria-busy", "true");
			} catch (_) {}

			// Lifecycle event: begin
			try {
				document.dispatchEvent(
					new CustomEvent("product-action:begin", {
						detail: { type: ACTION, button: btn },
					}),
				);
			} catch (_) {}

			// Show Yampi loader immediately for snappier UX
			try {
				window.showYampiLoader?.();
			} catch (_) {}

			try {
				await clearCart();
				await addToCart(form);

				// Lifecycle event: success
				try {
					document.dispatchEvent(
						new CustomEvent("product-action:success", {
							detail: { type: ACTION },
						}),
					);
				} catch (_) {}

				// Go to Yampi checkout
				if (typeof window.yampiClick === "function") {
					window.yampiClick();
				} else {
					window.location.href = "/cart?ref=yampi_buy_button";
				}
			} catch (err) {
				console.warn("[Yampi Buy Now] Error:", err);
				// Lifecycle event: error
				try {
					document.dispatchEvent(
						new CustomEvent("product-action:error", {
							detail: { type: ACTION, error: err },
						}),
					);
				} catch (_) {}

				alert(
					err?.message ||
						"Não conseguimos iniciar o checkout agora. Tente novamente ou finalize pelo carrinho.",
				);

				// Unlock & hide loader on failure only (success navigates away)
				btn.classList.remove("btn--loading");
				btn.removeAttribute("aria-disabled");
				try {
					window.hideYampiLoader?.();
				} catch (_) {}
				try {
					form.removeAttribute("aria-busy");
				} catch (_) {}
			}
		},
		{ passive: false },
	);
})();
